var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetailDisplays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3faff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59,48.36c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1,48.36c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.64,51.81c-.08,0-.17-.01-.25-.04l-19.57-6.83s-.05-.01-.08-.02l-9.63-3.34c-.39-.14-.6-.56-.46-.96.14-.39.56-.59.96-.46l9.57,3.32s.05.01.08.02l19.63,6.85c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.29,55.26c-.08,0-.17-.01-.25-.04l-29.5-10.29c-.31-.09-.53-.38-.53-.72,0-.41.33-.75.74-.75h.02c.08,0,.17.01.25.04l29.52,10.3c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.36,51.81c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l19.64-6.85s.06-.02.08-.02l9.55-3.32c.39-.14.82.07.95.46.14.39-.07.82-.46.95l-9.62,3.34s-.06.02-.08.02l-19.57,6.83c-.08.03-.17.04-.25.04Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.71,55.26c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l29.52-10.3c.48-.16,1.01.21,1.01.71,0,.36-.25.66-.58.73l-29.45,10.28c-.08.03-.17.04-.25.04Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.99,48.36c-.08,0-.17-.01-.25-.04l-28.75-10.02L1.25,48.31c-.39.14-.82-.07-.96-.46-.14-.39.07-.82.46-.96l28.99-10.1c.16-.06.33-.06.49,0l28.99,10.1c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,59.04c-.09,0-.18-.02-.26-.05L.74,48.31c-.29-.11-.48-.38-.49-.68s.17-.59.45-.71c.2-.08.42-.08.6,0l28.7,10.57,28.67-10.56c.19-.09.41-.11.62-.02.28.12.46.4.46.71,0,.31-.2.58-.49.69l-29,10.68c-.08.03-.17.05-.26.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.37,25.75c-.41,0-.75-.34-.75-.75V7.68c0-.41.34-.75.75-.75s.75.34.75.75v17.32c0,.41-.34.75-.75.75Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.63,31.57c-.41,0-.75-.34-.75-.75v-13.44c0-.41.34-.75.75-.75s.75.34.75.75v13.44c0,.41-.34.75-.75.75Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.98,18.22c-1.88,0-3.68-.77-4.99-2.1-1.31,1.33-3.11,2.1-4.99,2.1s-3.68-.77-4.99-2.1c-1.31,1.33-3.11,2.1-4.99,2.1-3.85,0-6.98-3.13-6.98-6.98s3.13-6.98,6.98-6.98h19.95c3.85,0,6.98,3.13,6.98,6.98s-3.13,6.98-6.98,6.98Zm-4.99-3.99c.24,0,.46.11.6.3,1.03,1.37,2.67,2.19,4.39,2.19,3.02,0,5.48-2.46,5.48-5.48s-2.46-5.48-5.48-5.48h-19.95c-3.02,0-5.48,2.46-5.48,5.48s2.46,5.48,5.48,5.48c1.71,0,3.36-.82,4.39-2.19.28-.38.92-.38,1.2,0,1.03,1.37,2.67,2.19,4.39,2.19s3.35-.82,4.39-2.19c.14-.19.36-.3.6-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.49,34.13h-20.97c-2.19,0-3.98-1.79-3.98-3.98v-9.89c0-.41.34-.75.75-.75s.75.34.75.75v9.89c0,1.37,1.11,2.48,2.48,2.48h20.97c1.37,0,2.48-1.11,2.48-2.48v-9.89c0-.41.34-.75.75-.75s.75.34.75.75v9.89c0,2.19-1.79,3.98-3.98,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.59,27.96c-.41,0-.75-.34-.75-.75v-3.54c0-.41.34-.75.75-.75s.75.34.75.75v3.54c0,.41-.34.75-.75.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailDisplays);
export default __webpack_public_path__ + "static/media/Retail Displays.402129b7f0fbdc3aed77070e240b215d.svg";
export { ForwardRef as ReactComponent };